<template>
  <div>
    <v-fade-transition mode="out-in">
      <component :is="component">
        <slot />
      </component>
    </v-fade-transition>
  </div>
</template>

<script>
import LayoutDefault from './components/layouts/Default';

export default {
  name: 'App',

  components: {
    LayoutDefault
  },

  computed: {
    component() {
      if (this.$route.path === '/error') {
        return 'error';
      }
      return 'layout-default';
    }
  },

  created() {
    this.$store.commit('IS_MOBILE', true);
  }
};
</script>

<style>
.material-icons.v-icon {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/App.vue